export default __webpack_public_path__ + "static/media/xitoy.e557b91d.png";